import {Link} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {PropsWithChildren} from 'react'

import {HTMLAnchorElementProps} from '../types'
import {footerClasses} from './FooterLink.classes'

export type FooterLinkProps = {
  rel?: HTMLAnchorElementProps['rel']
  target?: HTMLAnchorElementProps['target']
  size?: 'm' | 's'
  href?: string
}

export function FooterLink({children, size = 's', ...linkProps}: PropsWithChildren<FooterLinkProps>) {
  return (
    <Link className={clsx(footerClasses.root, footerClasses[`size_${size}`])} {...linkProps}>
      {children}
    </Link>
  )
}
